<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">巡检记录</div>
    </div>
    <div class="modul-search">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="设施名称">
          <el-select
            v-model="bridgeUuid"
            @change="bridgeChange"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in bridgeData"
              :key="index"
              :label="item.bridgeName"
              :value="item.bridgeUuid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="time"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          ><el-button type="primary" @click="tableReq(1)">查询</el-button></el-form-item
        >
      </el-form>
      <div style="float: right; display: flex">
        <el-button @click="addbaobiao">月度巡查表</el-button>
        <!-- <el-button @click="addAnjuan">案卷上报</el-button> -->
        <el-button @click="downloads" style="float: right">批量下载</el-button>
      </div>
    </div>
    <el-table
      class="tableStyle"
      v-loading="loading"
      height="calc(100vh - 350px)"
      border
      style="width: 100%"
      :data="tableData"
      :header-cell-style="{
        background: '#FAFAFA',
        color: '#000000',
        'text-align': 'left'
      }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        label="序号"
        align="left"
        type="index"
        width="50px"
      ></el-table-column>
      <el-table-column prop="bridgeName" label="设施名称" align="left"></el-table-column>
      <el-table-column prop="curingUtil" label="巡查单位" align="left"></el-table-column>
      <el-table-column
        prop="perambulationTime"
        label="巡视日期"
        align="left"
      ></el-table-column>
      <!-- <el-table-column
        prop="perambulationPeopleSignature"
        label="巡查人签名"
        align="left"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.perambulationPeopleSignature"
            style="width: 100px; height: 30px"
            alt="签名"
          />
        </template>
      </el-table-column> -->
      <el-table-column prop="status" label="月度巡查表状态" align="left">
        <template slot-scope="scope">
          <div>{{ scope.row.status == 0 ? '异常' : '正常' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="name5" label="月度巡查表" align="left">
        <template slot-scope="scope">
          <img
            src="@/assets/image/old/文件夹@2x.png"
            alt=""
            style="width: 20px; height: 20px; margin-right: 5px"
          />
          <a
            href="javascript:void(0);"
            @click="detailsRow(scope.row)"
            style="color: #11528b"
            >{{ scope.row.dailyStatementName }}</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="name3" label="操作" align="left">
        <template #default="scope">
          <el-button class="btn" type="text" @click="detailsRow(scope.row)"
            >下载</el-button
          >
          <el-button class="btn" type="text" @click="delRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  -->
    <div style="text-align: center; margin: 20px 0 0">
      <el-pagination
        @size-change="handleSizeChange"
        :hide-on-single-page="!total"
        @current-change="handleCurrentChange"
        :current-page="form.pageNum"
        :page-sizes="[10, 20, 30]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="55%"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        style="text-align: left"
      >
        <el-row type="flex">
          <el-col :span="22">
            <el-form-item label="照片" prop="reportPicture">
              <img-upload
                class="upload-margin"
                :imageUrl="ruleForm.reportPicture"
                ref="bridgeSidePictureUrl"
                :limit="99"
              ></img-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="经度" prop="lng">
              <el-input v-model="ruleForm.lng" placeholder="请输入经度">
                <el-button
                  @click="getMapClick(ruleForm)"
                  slot="append"
                  icon="el-icon-location-outline"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="纬度" prop="lat">
              <el-input v-model="ruleForm.lat" placeholder="请输入纬度"
                ><el-button slot="append" icon="el-icon-location-outline"></el-button
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="位置描述" prop="locationdDescribe">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 8 }"
                maxlength="150"
                show-word-limit
                v-model="ruleForm.locationdDescribe"
                placeholder="请输入位置描述"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="设施名称">
              <el-select
                style="width: 100%"
                v-model="ruleForm.bridgeUuid"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in bridgeData"
                  :key="index"
                  :label="item.bridgeName"
                  :value="item.bridgeUuid"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="问题类型">
              <el-select
                style="width: 100%"
                v-model="ruleForm.problemType"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in errorList"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="案卷描述" prop="caseDescribe">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 8 }"
                maxlength="1500"
                show-word-limit
                v-model="ruleForm.caseDescribe"
                placeholder="请输入案卷描述"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="title">
        <div class="modul-top1">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">案卷上报</div>
        </div>
      </span>
      <div slot="footer" class="anniu">
        <el-button type="primary" @click="add_sure()">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="mapDialog"
      :modal="false"
      append-to-body
      title="地图选点"
      style="width: 100%"
    >
      <getMap
        @getLngLat="getLngLat"
        @close="mapDialog = false"
        ref="getMap"
        :Mapcenter="Mapcenter"
      ></getMap>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogbaobiaoVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="55%"
    >
      <span slot="title">
        <div class="modul-top1">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">月度巡查表</div>
        </div>
      </span>
      <el-form
        style="max-height: 400px; overflow: auto; text-align: left"
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
      >
        <el-row>
          <el-col :span="11">
            <el-form-item label="设施名称">
              <el-select
                style="width: 100%"
                v-model="baobiaoForm.bridgeUuid"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in bridgeData"
                  :key="index"
                  :label="item.bridgeName"
                  :value="item.bridgeUuid"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="巡查日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="baobiaoForm.perambulationTime"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="天气情况"
              ><el-input
                v-model="baobiaoForm.weather"
                placeholder="请输入天气情况"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="现场巡查照片">
              <img-upload
                class="upload-margin"
                :imageUrl="baobiaoForm.picList"
                :limit="10"
              ></img-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-for="(item, i) in baobiaoForm.informationList" :key="i">
          <el-col :span="24">
            <el-form-item :label="item.inspectionItem" class="choose-state">
              <el-form-item label="是否正常运行">
                <el-radio-group v-model="baobiaoForm.informationList[i].state">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <template v-if="baobiaoForm.informationList[i].state === '1'">
                <el-form-item label="图片">
                  <img-upload
                    class="upload-margin"
                    :imageUrl="baobiaoForm.informationList[i].diseaseNum"
                    ref="bridgeSidePictureUrl"
                    :limit="10"
                  ></img-upload>
                </el-form-item>
                <el-form-item label="说明">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 6, maxRows: 8 }"
                    maxlength="150"
                    show-word-limit
                    v-model="baobiaoForm.informationList[i].diseaseExplain"
                    placeholder="请输入案卷描述"
                  ></el-input>
                </el-form-item>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="anniu">
        <el-button type="primary" @click="add_baobiao_sure()">确 定</el-button>
        <el-button @click="dialogbaobiaoVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/api/config.js';
import imgUpload from '@/views/components/upLoad/imgUpload.vue';
import getMap from '@/views/components/getMap/index.vue';
import moment from 'moment';
export default {
  name: 'DeqingBridgeAndTunnelXunchajihua',
  components: { imgUpload, getMap },
  props: [],
  data() {
    return {
      form: {
        bridgeName: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 10
      },
      // 地图选点显示框
      mapDialog: false,
      Mapcenter: [], //传入组件的经纬度 Mapcenter:[lng,lat]
      // facList:[],
      loading: false,
      tableData: [],
      total: 0,
      time: [],
      bridgeUuid: '',
      bridgeData: {},
      caozuoxy: true,
      options: [],
      FormData: {
        value: '',
        value1: [],
        value2: '',
        value22: '天',
        time: ''
      },
      multipleSelection: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },
          {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      dialogFormVisible: false,
      ruleForm: {
        dataSourceType: 'case_data_source_dailyreport',
        caseExceptionStatus: 'case_exception_status_bridge',
        caseType: 'case_type_roadbridge',
        reportPicture: []
      },
      errorList: [
        '隔离栏',
        '其他',
        '护栏',
        '桥梁',
        '树围',
        '井盖',
        '沥青路面',
        '道板',
        '砼路面',
        '石墩',
        '缘石坡道',
        '道路积水',
        '花坛',
        '道路开挖'
      ],
      dialogbaobiaoVisible: false,
      baobiaoForm: {
        picList: [],
        perambulationPeopleSignature: '',
        informationList: [
          {
            inspectionItem: 'GNSS',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },
          {
            inspectionItem: '振动加速度',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },
          {
            inspectionItem: '桥面线性',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },

          {
            inspectionItem: '环境温湿度',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },

          {
            inspectionItem: '索力加速度',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },

          {
            inspectionItem: '表面应变',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          }
        ]
      }
    };
  },

  mounted() {
    this.getBiBridgeBoPage();
    this.tableReq();
  },

  methods: {
    async tableReq(page) {
      this.loading = true;
      if (page) {
        this.form.pageNum = page;
      }
      let data = {
        ...this.form
      };
      console.log(data);
      const res = await this.$api.sendPost('/urbanBridge/getInspectionRecord', data);
      console.log('表格数据', res);
      this.loading = false;
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.tableData = [];
        }
      }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.tableReq(1);
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.form.pageNum = val;
      this.tableReq();
    },
    //时间选择
    timeChange(e) {
      let time = JSON.parse(JSON.stringify(e));
      if (time != undefined && time.length > 0) {
        this.form.startTime = time[0];
        this.form.endTime = time[1];
      } else {
        this.form.startTime = '';
        this.form.endTime = '';
      }
    },
    // 设备类型选择
    async equipmentTypeChange(e) {
      this.form.equipmentTypeUuid = e;
    },
    // 获取-设施名称列表
    async getBiBridgeBoPage() {
      let data = {
        pageSize: 99999,
        pageNum: 1
      };
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data);
      console.log('设施名称', res);
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeData = res.data.list;
        } else {
          this.bridgeData = [];
        }
      }
    },
    // 设施名称选择
    async bridgeChange(e) {
      if (this.bridgeUuid != '') {
        let add = this.bridgeData.find((item) => {
          return this.bridgeUuid == item.bridgeUuid;
        });
        this.form.bridgeName = add.bridgeName;
      } else {
        this.form.bridgeName = '';
      }
    },
    //删除
    async delRow(data) {
      const res = await this.$api.sendGet('/urbanBridge/delete', {
        id: data.id
      });
      this.tableReq();
    },
    handleSelectionChange(val) {
      if (val) {
        this.multipleSelection = val;
      } else {
        this.multipleSelection = [];
      }
    },
    //下载
    detailsRow(item) {
      console.log(item);
      let data = {};
      data.bridgeUuidList = [item.bridgeUuid];
      // data.idList=[item.id]
      data.perambulationTimeList = [moment(item.perambulationTime).format('YYYY-MM')];
      this.xiazai(data);
    },
    xiazai(data) {
      axios({
        method: 'post',
        url: this.$config.host + '/urbanBridge/exportExcel',
        // formInline.reportState
        params: {},
        data: data,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          token: sessionStorage.getItem('token')
        }
      })
        .then((res) => {
          this.loading = false;
          const link = document.createElement('a');
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
            // type: "application/pdf;charset=utf-8",  //.pdf
          });
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          link.download = '巡检月度巡查表' + '.xls'; //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //批量下载
    downloads() {
      if (this.multipleSelection.length > 0) {
        let list = [];
        let perambulationTimeList = [];
        this.multipleSelection.forEach((item) => {
          list.push(item.bridgeUuid);
          perambulationTimeList.push(moment(item.perambulationTime).format('YYYY-MM'));
          // idList.push(item.id)
        });
        let data = {};
        data.bridgeUuidList = list;
        data.perambulationTimeList = perambulationTimeList;
        this.xiazai(data);
      }
    },
    getMapClick(data) {
      this.mapDialog = true;
      if (data.longitude && data.latitude) {
        this.Mapcenter = [
          Number(this.ruleForm.longitude),
          Number(this.ruleForm.latitude)
        ];
      }
      console.log(this.Mapcenter);
    },
    getLngLat(lng, lat, a) {
      this.ruleForm.lng = lng;
      this.ruleForm.lat = lat;
      this.ruleForm.locationdDescribe = a;
      console.log(this.ruleForm.locationdDescribe);
      this.mapDialog = false;
    },
    async add_sure() {
      if (this.ruleForm.bridgeUuid) {
        let add = this.bridgeData.find((item) => {
          return this.ruleForm.bridgeUuid == item.bridgeUuid;
        });
        this.ruleForm.bridgeName = add.bridgeName;
      }
      let reportPicture = [];
      if (this.ruleForm.reportPicture && this.ruleForm.reportPicture.length > 0) {
        reportPicture = this.ruleForm.reportPicture.map((item) => item.url).join(',');
      }
      let data = {
        reportPeopleName: this.$store.state.user.accountName,
        reportPeopleUuid: this.$store.state.user.accountUuid,
        ...this.ruleForm,
        reportPicture
      };
      const res = await this.$api.sendPost('/report/insertReport', data);
      if (res.errcode == 0) {
        this.$message.success('保存成功');
      } else {
        this.$message.error(res.errmsg);
      }
    },
    async add_baobiao_sure() {
      let day;
      if (this.baobiaoForm.perambulationTime) {
        switch (moment(this.baobiaoForm.perambulationTime).day()) {
          case 0:
            day = '星期日';
            break;
          case 1:
            day = '星期一';
            break;
          case 2:
            day = '星期二';
            break;
          case 3:
            day = '星期三';
            break;
          case 4:
            day = '星期四';
            break;
          case 5:
            day = '星期五';
            break;
          case 6:
            day = '星期六';
            break;
          default:
            break;
        }
      }
      if (this.baobiaoForm.bridgeUuid) {
        let add = this.bridgeData.find((item) => {
          return this.baobiaoForm.bridgeUuid == item.bridgeUuid;
        });
        this.baobiaoForm.bridgeName = add.bridgeName;
      }
      let informationList = [];
      let flag = false;
      this.baobiaoForm.warnComponentImg =
        this.baobiaoForm.picList.length > 0
          ? this.baobiaoForm.picList.map((item) => item.url).join(',')
          : '';
      this.baobiaoForm.informationList.forEach((item) => {
        if (item.state === null) {
          flag = true;
        } else {
          if (item.diseaseNum && item.diseaseNum.length > 0) {
            informationList.push({
              ...item,
              diseaseNum: item.diseaseNum.map((subitem) => subitem.url).join(',')
            });
          } else {
            informationList.push({
              ...item,
              diseaseNum: ''
            });
          }
        }
      });
      if (flag) {
        this.$message.error('请完善设备信息');
        return false;
      }
      let data = {
        perambulationPeopleName: this.$store.state.user.accountName,
        perambulationPeopleUuid: this.$store.state.user.accountUuid,
        ...this.baobiaoForm,
        perambulationTime: this.baobiaoForm.perambulationTime
          ? moment(this.baobiaoForm.perambulationTime).format('YYYY年MM月')
          : '',
        weekDay: day,
        informationList
      };
      console.log('this.ruleForm', data);
      const res = await this.$api.sendPost('/urbanBridge/insertUrbanBridge', data);
      if (res.errcode == 0) {
        this.$message.success('保存成功');
        this.dialogbaobiaoVisible = false;
      } else {
        this.$message.error(res.errmsg);
      }
    },
    addbaobiao() {
      this.dialogbaobiaoVisible = true;
      this.baobiaoForm = {
        picList: [],
        perambulationPeopleSignature: '',
        informationList: [
          {
            inspectionItem: 'GNSS',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },
          {
            inspectionItem: '振动加速度',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },
          {
            inspectionItem: '桥面线性',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },
          {
            inspectionItem: '环境温湿度',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },
          {
            inspectionItem: '索力加速度',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          },

          {
            inspectionItem: '表面应变',
            condition: '正常',
            state: null,
            diseaseName: '病害现场图',
            diseaseNum: [],
            diseaseExplain: ''
          }
        ]
      };
    },
    addAnjuan() {
      this.dialogFormVisible = true;
      this.ruleForm = {
        dataSourceType: 'case_data_source_dailyreport',
        caseExceptionStatus: 'case_exception_status_bridge',
        caseType: 'case_type_roadbridge',
        reportPicture: []
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
/deep/ .el-form-item__label {
  text-align: left;
  width: 180px;
  padding: 0 10px;
}
</style>
